import { render, staticRenderFns } from "./order_history.vue?vue&type=template&id=3fbf3d9c&scoped=true&"
import script from "./order_history.vue?vue&type=script&lang=js&"
export * from "./order_history.vue?vue&type=script&lang=js&"
import style0 from "./order_history.vue?vue&type=style&index=0&id=3fbf3d9c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbf3d9c",
  null
  
)

export default component.exports